import { render, staticRenderFns } from "./HelpCardContent.vue?vue&type=template&id=cb896fb4&scoped=true&"
import script from "./HelpCardContent.vue?vue&type=script&lang=js&"
export * from "./HelpCardContent.vue?vue&type=script&lang=js&"
import style0 from "./HelpCardContent.vue?vue&type=style&index=0&id=cb896fb4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb896fb4",
  null
  
)

export default component.exports